import React from 'react';
import { AwardIcon, CheckIcon, FlameIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { checkoutUrl, included, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-carbon py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-181" data-mp="1jas0wn0augzf">
      <div className="mx-auto max-w-3xl px-4" data-id="element-182" data-mp="1s9n6bwvirn1o">
        <SectionHeading id="pricing-title" data-id="element-183" data-mp="1s8c3bz9wejbm">Choose your option</SectionHeading>

        <article className="mt-10 overflow-hidden rounded-3xl border-2 border-energy bg-petrol shadow-2xl shadow-black/50" data-id="element-184" data-mp="1x8glruud9o4h">
          <div className="flex flex-wrap items-center justify-between gap-3 border-b border-lava/30 bg-carbon/50 px-6 py-4 sm:px-10" data-id="element-185" data-mp="226i6ek7fxvi2">
            <span className="inline-flex items-center gap-2 rounded-full bg-lava px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.14em] text-carbon" data-id="element-186" data-mp="2x1u38hspem3">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-187" data-mp="1mhg9skngd5a3" /> Main offer
            </span>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-energy px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.14em] text-carbon" data-id="element-188" data-mp="1hp6e0nznpazw">
              <FlameIcon className="h-3.5 w-3.5 text-lava" aria-hidden="true" data-id="element-189" data-mp="17sadb4g01t5w" /> 50% off today
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-190" data-mp="25e7qcmbm16ag">
            <div className="flex flex-col gap-6 border-b border-white/10 pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-191" data-mp="25d6fahulgjsq">
              <div data-id="element-192" data-mp="1vh34knlofcu6">
                <h3 className="font-display text-3xl font-bold leading-tight text-snow" data-id="element-193" data-mp="1vgbh6028glez">{productShortName}</h3>
                <p className="mt-2 text-sm text-muted" data-id="element-194" data-mp="1rezn9icbte0z">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses ready to use in your classroom.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-195" data-mp="fz19502ak1sw">
                <span className="text-sm text-muted" data-id="element-196" data-mp="hi1b1ywvo0ia">
                  Regular price: <span className="line-through decoration-lava decoration-2" data-id="element-197" data-mp="hfowzwu8qaai">{priceBefore}</span>
                </span>
                <p className="mt-1 whitespace-nowrap font-display text-6xl font-bold leading-none text-energy" data-id="element-198" data-mp="7jlqkescvphr">{price}</p>
                <p className="mt-2 text-xs font-bold uppercase tracking-[.14em] text-lava" data-id="element-199" data-mp="chvq11l45c96">Today · 50% discount</p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-200" data-mp="3uul6uyv6w3jp">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-snow" data-id="element-201" data-mp="3k359hwmhcee">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-lava" aria-hidden="true" data-id="element-202" data-mp="3kwnhg81lg0pi" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-203" data-mp="3bybtyew0xj1a">
              Get my teacher ready now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-204" data-mp="2xc4px7gm1g1r">
              <span className="inline-flex items-center gap-1.5" data-id="element-205" data-mp="2sdbl03fe2xd7">
                <LockIcon className="h-4 w-4 text-lava" aria-hidden="true" data-id="element-206" data-mp="36cb12mou63xr" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-207" data-mp="31cf4h8igxes8">
                <ZapIcon className="h-4 w-4 text-lava" aria-hidden="true" data-id="element-208" data-mp="3g9z5k4c8upt4" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-209" data-mp="3bb4bu7cqngu8">
                <ShieldCheckIcon className="h-4 w-4 text-lava" aria-hidden="true" data-id="element-210" data-mp="3b8ry66e0jsmz" /> 7-day guarantee
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-muted" data-id="element-211" data-mp="3l05u646raabd">
              You pay in USD. Your payment platform automatically shows the conversion to your local currency.
            </p>
          </div>
        </article>
      </div>
    </section>;
}